import React, { useContext, useEffect, useState } from "react";
import PropTypes from "prop-types";
import { FormContext, FormContextProvider } from "@sw-sw/lib-form";
import FormModal from "../Shared/form/modal/FormModal";
import { customDashboard } from "../../utils/api/dashboard";
import Loading from "../Shared/ResourceIndex/Loading";

const CustomModalContent = ({
  hideModal,
  handleSubmit,
  subTitle,
  displayObject
}) => {
  const [findingTypeListForOverdueFindings, setFindingTypeListForOverdueFindings] = useState([])
  const [isLoading, setIsLoading] = useState(false)
  const formContext = useContext(FormContext);

  useEffect(() => {
    setIsLoading(true)
    customDashboard.fetch(`/divisions/1/findingsOverview/fetchFindingTypesUsed`)
    .then(res => {
      setFindingTypeListForOverdueFindings(res);
      setIsLoading(false)
    })
  }, [])

  return (
    <FormModal
      modalProps={{
        title: "Finding Type Filter",
      }}
      onCancel={hideModal}
      onSubmit={() => handleSubmit(formContext.value.selectedIds || [])}
      submitText="Save"
    >
      {!isLoading ? (findingTypeListForOverdueFindings.map((ele, index) => {
        return (
          <label key={index} style={{ display: 'flex', alignItems: 'center', gap: '10px', height: '40px' }}>
            <input
              type="checkbox"
              name="finding-type1"
              value={ele.id}
              checked={formContext.value.selectedIds?.includes(ele.id) || false}
              onChange={(e) => {
                const currentSelected = formContext.value.selectedIds || [];
                const newSelected = e.target.checked
                  ? [...currentSelected, ele.id]
                  : currentSelected.filter(id => id !== ele.id);
                  
                formContext.set('selectedIds', newSelected);
              }}
              style={{ width: '20px', height: '20px' }}
            />
            <span>{ele.name}</span>
          </label>
        )
      }))
      : <Loading what="finding types"/>
      }
    </FormModal>
  );
};

const CustomModal = ({
  show,
  hideModal,
  handleSubmit,
  subTitle,
  displayObject,
  selectedIds = []
}) => {
  if (!show) {
    return null;
  }

  return (
    <FormContextProvider initialValue={{ selectedIds }}>
      <CustomModalContent
        hideModal={hideModal}
        handleSubmit={handleSubmit}
        subTitle={subTitle}
        displayObject={displayObject}
      />
    </FormContextProvider>
  );
};

CustomModal.propTypes = {
  show: PropTypes.bool.isRequired,
  hideModal: PropTypes.func.isRequired,
  handleSubmit: PropTypes.func.isRequired,
  subTitle: PropTypes.string,
  displayObject: PropTypes.array.isRequired,
  selectedIds: PropTypes.array,
};

export default CustomModal;
